window.theme = window.theme || {};

let $body = $("body");
let $html = $("html");
let $ajaxUpdate = $(".js-update");
let $ajaxLoader = $(".loader");
let $ajaxPopupComplete = function () {
  popupApp.clear();
};
$body.append(
  '<div class="loader"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></div>',
);

$(function () {
  var core = (function () {
    return {
      init: function () {
        core.initWebPcheck();
        core.initFixedHeader();
        core.initReadProgress();
        core.initDefault();
        core.initResize();
        //core.initPhoneMask();
        //core.initQty();
        //core.contentProtect();
      },
      isTouchDevice: function () {
        try {
          document.createEvent("TouchEvent");
          return true;
        } catch (e) {
          return false;
        }
      },
      initWebPcheck: function () {
        let elem = document.createElement("canvas");
        if (!!(elem.getContext && elem.getContext("2d"))) {
          document.documentElement.classList.add("is-webp");
          return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } else {
          document.documentElement.classList.add("is-no-webp");
          return false;
        }
      },
      initResize: function () {
        if (core.getViewPort().width > 1199) {
          $(".is-no-touchdevice .js-main-menu .nav__item.is-dd").hover(
            function () {
              let el = $(this).find(".nav__dd");
              setTimeoutConst = setTimeout(function () {
                $body.addClass("js-h-catalog-over");
                $body.addClass("js-h-menu-show");
              }, 300);
            },
            function () {
              clearTimeout(setTimeoutConst);
              $body.removeClass("js-h-catalog-over");
              $body.removeClass("js-h-menu-show");
            },
          );
        }
      },
      initReadProgress: function () {
        if ($(".js-read-progress").length) {
          $(".js-read-progress").prepend('<div id="pageProgress"></div>');
          let processScroll = () => {
            let docElem = document.documentElement,
              docBody = document.body,
              scrollTop = docElem["scrollTop"] || docBody["scrollTop"],
              scrollBottom =
                (docElem["scrollHeight"] || docBody["scrollHeight"]) -
                window.innerHeight,
              scrollPercent = (scrollTop / scrollBottom) * 100 + "%";
            document
              .getElementById("pageProgress")
              .style.setProperty("--scrollAmount", scrollPercent);
          };
          document.addEventListener("scroll", processScroll);
        }
      },
      initFixedHeader: function () {
        let fixed = false;
        let height = 200;
        let lastScrollTop = 0;
        $(window).scroll(function () {
          let st = $(this).scrollTop();

          if (st > height) {
            if (!fixed) {
              fixed = true;
              $body.addClass("js-fixed-header");
            }
          } else {
            if (fixed) {
              fixed = false;
              $body.removeClass("js-fixed-header");
            }
          }

          if (st > lastScrollTop) {
            $body.removeClass("js-scroll-top");
            $body.addClass("js-scroll-down");
          } else {
            $body.removeClass("js-scroll-down");
            $body.addClass("js-scroll-top");
          }
          lastScrollTop = st;
        });
      },
      contentProtect: function () {
        $body.bind("cut copy paste contextmenu dragstart", function (e) {
          e.preventDefault();
        });
      },
      addResponsiveToContent: function () {
        if ($(".editor").length) {
          $("table").wrap('<div class="table__wrapper"></div>');
        }
      },
      hideLoader: function () {
        $ajaxUpdate.fadeTo("opacity", "1");
        $body.removeClass("js-loader-show");
      },
      showLoader: function (a) {
        var timer = a;
        $body.addClass("js-loader-show");
        if (timer) {
          setTimeout(core.hideLoader(), timer);
        }
        $ajaxUpdate.fadeTo("opacity", "0.6");
      },
      resetErrors: function () {},
      findErrors: function () {},
      initPhoneMask: function () {},
      initQty: function () {
        $(".js-qty--input").each(function () {
          var num = $(this).find("input");
          $(this)
            .find(".js-qty--plus")
            .on("click", function () {
              var inputVal = parseInt(num.val(), 10);
              if (inputVal <= 0 || !$.isNumeric(inputVal)) {
                inputVal = 0;
              }
              num.val(++inputVal).trigger("change");
              return false;
            });
          $(this)
            .find(".js-qty--minus")
            .on("click", function () {
              var inputVal = parseInt(num.val(), 10);
              if (inputVal < 1 || !$.isNumeric(inputVal)) inputVal = 1;
              num.val(--inputVal).trigger("change");
              return false;
            });
        });
      },
      getViewPort: function () {
        var e = window,
          a = "inner";
        if (!("innerWidth" in window)) {
          a = "client";
          e = document.documentElement || document.body;
        }
        return { width: e[a + "Width"], height: e[a + "Height"] };
      },
      getEmailFilter: function () {
        return {
          filter:
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
        };
      },

      initDefault: function () {
        $html.removeClass("no-js");

        if (core.isTouchDevice()) {
          $html.addClass("is-touchdevice");
        } else {
          $html.addClass("is-no-touchdevice");
        }

        core.addResponsiveToContent();

        // forms keydown
        $("*[data-allow]").on("keydown", function (e) {
          var allow = $(this).data("allow");
          var key = e.keyCode;
          var base = [8, 9, 27]; // backspace, tab, escape
          var numbers = [
            48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101,
            102, 103, 104, 105,
          ];
          var spec = [
            189, 187, 219, 221, 220, 186, 222, 191, 110, 111, 106, 109, 107,
            192,
          ];
          var space = 32;
          var enter = 13;
          if (allow == "abc") {
            if ($.inArray(key, spec) !== -1 || $.inArray(key, numbers) !== -1) {
              e.preventDefault();
            }
          }
          if (allow == "num") {
            if (
              $.inArray(key, base) !== -1 ||
              (key == 65 && e.ctrlKey === true) ||
              (key >= 35 && key <= 40)
            ) {
              return;
            }
            if (
              (e.shiftKey || key < 48 || key > 57) &&
              (key < 96 || key > 105)
            ) {
              e.preventDefault();
            }
          }
        });

        // default toggle
        $(".js-toggle").on("click", function () {
          $(this).parent().toggleClass("is-open");
        });

        // default tabs
        $(".tabs__group").each(function () {
          var t = $(this);
          var links = t.find(">.tabs__links .item");
          var tabs = t.find(">.tabs__content > .tab__item");
          tabs
            .removeClass("is-selected")
            .filter(":first")
            .addClass("is-selected");
          links.filter(":first").addClass("is-selected");
          links.click(function () {
            var target = $(this).data("tab");
            console.log(target);
            tabs.removeClass("is-selected");
            $(".tab__item--" + target).addClass("is-selected");
            links
              .removeClass("is-selected")
              .filter($(this))
              .addClass("is-selected");
          });
        });

        // js link
        $("*[data-link]").on("click", function () {
          location.href = $(this).data("link");
        });

        // scroll to target
        $("*[data-scroll]").each(function () {
          $(this).on("click", function () {
            var header = $(".header").outerHeight();
            var target = $(this).attr("data-scroll");
            $("html,body").animate(
              { scrollTop: $("." + target).offset().top - 70 },
              300,
            );
          });
        });

        // popup open
        $("*[data-popup]").on("click", function () {
          popupApp.open($(this).data("popup"));
        });
      },
    };
  })();

  var popupApp = (function () {
    return {
      init: function () {
        popupApp.close();

        $("*[data-popup]").on("click", function (e) {
          popupApp.open($(this).data("popup"));
          return false;
        });
      },

      clear: function () {
        $body.removeClass("js-popup-show");
        $(".popup.is-shown").removeClass("is-shown");
        $(".popup .error").removeClass("error");
      },
      close: function (a) {
        $(".popup .js-close").on("click", function () {
          popupApp.clear();
        });
      },
      center: function (a) {
        var name = a;
        var popup = $(".popup--" + a);
        var wHeight = core.getViewPort().height / 2;
        var pTopPos = $(document).scrollTop() - 100;
        var pHeight = popup.outerHeight() / 2;
        pHeight = Math.round(pHeight);
        var pMarginTop = pTopPos + (wHeight - pHeight);
        popup.removeAttr("style");
        if (
          core.getViewPort().width <= 1024 ||
          popup.outerHeight() > core.getViewPort().height
        ) {
          var adjustment =
            a?.startsWith("bundle--") || a === "accessories" ? 140 : 0;
          popup.css("top", pTopPos + 40 + adjustment);
        } else {
          popup.css("top", pMarginTop);
        }
        if (a == "language") {
          languageApp.init();
        }
        if (a == "accessories") {
          accessoriesApp.init();
        }
        $body.addClass("js-popup-show");
        popup.addClass("is-shown").find("input[type=text]").first().focus();
      },
      open: function (a, b) {
        var state = b;
        if ($body.hasClass("js-popup-show")) {
          popupApp.clear();
        }

        popupApp.center(a);
      },
    };
  })();

  theme.popupApp = popupApp;

  let accessoriesApp = (function () {
    return {
      init: function () {
        $(".product__combo--accessories .group--accessories").each(function () {
          let item = $(this);
          let checkbox = item.find(".js-item-variant");
          let id = item.data("product-id");
          let itemInPopup = $(
            '.popup--accessories .bundle__item[data-product_id="' + id + '"]',
          );
          console.log(id);
          if (checkbox.is(":checked")) {
            itemInPopup.removeClass("is-hidden").addClass("is-visible");
          } else {
            itemInPopup.addClass("is-hidden").removeClass("is-visible");
          }

          let itemsToShow = $(
            ".popup--accessories .bundle__item.is-visible",
          ).length;
          if (itemsToShow > 1) {
            $(".popup--accessories")
              .removeClass("popup--lg")
              .addClass("popup--xl");
          } else {
            $(".popup--accessories")
              .removeClass("popup--xl")
              .addClass("popup--lg");
          }
        });

        $(".js-accsessories-submit").on("click", function () {
          $(".popup--accessories .bundle__item").each(function () {
            let item = $(this);
            let id = item.data("product_id");
            let selected = item.find(".bundle__selectbox option:selected");
            let value = selected.val();
            let price = selected.data("price");
            let compareAtPrice = selected.data("compare-at-price");
            let imgID = selected.data("media-id");
            let imgSrc = item
              .find('.bundle__image[data-media-id="' + imgID + '"] img')
              .attr("src");
            let previewItem = $(
              '.group--accessories[data-product-id="' + id + '"]',
            );

            if (previewItem.find(".js-item-variant").is(":checked")) {
              previewItem
                .addClass("is-selected")
                .removeClass("is-not-selected");
            }

            previewItem.find(".js-item-variant").attr("data-variant", value);
            previewItem.find(".price--default").html(price);
            if (compareAtPrice) {
              previewItem.find(".price--old").html(compareAtPrice);
            }
            previewItem.find(".group__imageSrc").attr("src", imgSrc);
          });

          popupApp.clear();

          // if ($(".product__topstory .js-bundle-submit").is(":visible")) {
          //   let selectedBundle = $(".js-bundle-check:checked").data(
          //     "popup-num"
          //   );
          //   popupApp.open("bundle--" + selectedBundle);
          // } else {
          //   accessoriesApp.addToCart();
          //   if ($(".js-product-buy.is-proceed").length) {
          //     // accessoriesApp.addToCart(); // ttt
          //   }
          // }

          // TODO: fix
          if (window.CustomizableATC) {
            window.CustomizableATC();
          } else {
            addToCart();
          }
        });

        $(".js-accsessories-save").on("click", function () {
          $(".popup--accessories .bundle__item").each(function () {
            let item = $(this);
            let id = item.data("product_id");
            let selected = item.find(".bundle__selectbox option:selected");
            let value = selected.val();
            let price = selected.data("price");
            let compareAtPrice = selected.data("compare-at-price");
            let imgID = selected.data("media-id");
            let imgSrc = item
              .find('.bundle__image[data-media-id="' + imgID + '"] img')
              .attr("src");
            let previewItem = $(
              '.group--accessories[data-product-id="' + id + '"]',
            );

            if (previewItem.find(".js-item-variant").is(":checked")) {
              previewItem
                .addClass("is-selected")
                .removeClass("is-not-selected");
            }

            previewItem.find(".js-item-variant").attr("data-variant", value);
            previewItem.find(".price--default").html(price);
            if (compareAtPrice) {
              previewItem.find(".price--old").html(compareAtPrice);
            }
            previewItem.find(".group__imageSrc").attr("src", imgSrc);
          });

          popupApp.clear();
          // TODO: fix
          // if (window.CustomizableATC) {
          //   window.CustomizableATC()
          // } else {
          //   // TODO BUNDLES
          //   if (window.USE_NEW_BUNDLES) {
          //     theme.addToCart(document.querySelector(".js-product-form"))
          //   } else {
          //     addToCart()
          //   }
          // }
        });

        $(".popup--accessories .bundle__item .bundle__selectbox").on(
          "change",
          function () {
            let select = $(this);
            let accs = select.parents(".bundle__item:first");
            let accsID = accs.data("product_id");
            let selected = select.find("option:selected");
            let selectedVal = select.val();
            let mediaID = selected.data("media-id");
            let cat = selected.data("cat");
            let selectedImg = accs.find(
              '.bundle__image[data-media-id="' + mediaID + '"]',
            );

            accs.find(".bundle__image").addClass("hide");
            selectedImg.removeClass("hide");

            if (accs.find(".product__tags").length) {
              accessoriesApp.checkCat(accsID, cat);
            }
          },
        );
      },
      addToCart: function () {
        let items = [];
        let base_prod_id = $(".product-single__variants").val();

        items.push({
          id: base_prod_id,
          quantity: 1,
        });

        try {
          const bundle_id = $(".bc-bundle-section .group__value:checked").data(
            "bundle-id",
          );
          if (bundle_id) {
            addBoughtToghetherProductsToCartGeneral(bundle_id);
            return;
          }
        } catch (error) {
          console.error(error);
        }

        $(".product__combo--accessories .group .group__value:checked").each(
          function () {
            let id = $(this).data("variant");
            items.push({
              id: id,
              quantity: 1,
            });
          },
        );

        if (items.length === 0) {
          return false;
        }

        core.showLoader();
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: { items },
          dataType: "json",
        };

        // Custom code: AU migration
        $.ajax(params)
          .done(function (ret_cart) {
            if (typeof window.HSSLIDECART !== "undefined") {
              Hs_CartDrawer.updateSlideCart();
              Hs_CartDrawer.getSlideCart();
              // HsCartDrawer.updateSlideCart();
              // HsCartDrawer.getSlideCart();
            } else {
              window.location.replace("/cart");
            }
            core.hideLoader();
          })
          .fail(function (code) {
            core.hideLoader();
            alert("There was an error while adding this product to cart.");
            console.log("error adding to cart, out of stock?");
          });
      },
      checkCat: function (_id, _cat) {
        const catWidgets = document.querySelectorAll(
          `.popup--accessories .bundle__item[data-product_id="${_id}"] .product__tags`,
        );
        catWidgets.forEach((widget) =>
          widget
            .querySelectorAll(".tag")
            .forEach((t) => t.classList.remove("is-selected")),
        );
        catWidgets.forEach((widget) =>
          widget
            .querySelector(`.tag[data-type="${_cat}"]`)
            .classList.add("is-selected"),
        );
      },
    };
  })();

  // TODO BUNDLES
  async function submitAddToCart(form) {
    // const body = Object.fromEntries(formData.entries());
    // console.log(body)

    // const ITEM_KEYS = ["id", "quantity", "selling_plan", "properties"]

    // for (const [k, v] of [...formData.entries()].filter(([k]) => ITEM_KEYS.includes(k))) {
    //   formData.set(`items[0]${k}`, v)
    //   formData.delete(k)
    // }

    // try {
    //   const faceScanInput = document.querySelector("#FaceWidth");
    //   if (faceScanInput && !faceScanInput.checkValidity()) {
    //       faceScanInput.reportValidity();
    //       return false;
    //   }

    //   if (faceScanInput) {
    //     items[0].properties = {
    //       "Face width": faceScanInput.value
    //     }
    //   }
    // } catch (error) {
    //   console.error(error)
    // }

    try {
      const faceScanCheckbox = document.querySelector("#FaceWidthCheckbox");
      if (faceScanCheckbox) {
        const faceScanResult = window.Shopify.FaceScan.handleAtc();
        if (faceScanResult === false) {
          return;
        }
      }
    } catch (error) {
      console.error(error);
    }

    const accessoryCheckboxes = document.querySelectorAll(
      ".product__combo--accessories .group .group__value:checked",
    );
    let c = 1;
    const accInputs = [];
    for (const el of [...accessoryCheckboxes]) {
      const accInput = document.createElement("input");
      accInput.name = `items[Accessory${c}]id`;
      accInput.value = el.dataset.variant;
      accInput.type = "hidden";
      form.appendChild(accInput);
      accInputs.push(accInput);
      // formData.set(`items[Accessory${c}]id`, el.dataset.variant)
      // formData.set(`items[Accessory${c}]quantity`, "1")
      c++;
    }

    const formData = new FormData(form);

    core.showLoader();

    try {
      const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        body: formData,
      });
      setTimeout(function () {
        window.location.replace("/cart");
      }, 1000);
    } catch (error) {
      console.error(error);
      console.log("error adding to cart, out of stock?");
    }
    core.hideLoader();

    for (const el of accInputs) {
      el.remove();
    }
  }

  theme.addToCart = submitAddToCart;

  var languageApp = (function () {
    return {
      init: function () {
        let form = $(".form--language");
        let localeSelect = form.find(".js-language-select");
        let countrySelect = form.find(".js-currency-select");
        let origLocalSelect = $("#locale_code");
        let origCurrencySelect = $("#country_code");

        // localeSelect.html($('#locale_code option').clone()).val(origLocalSelect.val());
        // countrySelect.html($('#country_code option').clone()).val(origCurrencySelect.val());

        form.find(".js-language-submit").on("click", function () {
          origLocalSelect.val(localeSelect.val());
          origCurrencySelect.val(countrySelect.val());

          // Custom code: AU redirect
          if (countrySelect.val() === "AU") {
            window.location.href = "https://nakedoptics.com.au/";
            return;
          }
          core.showLoader();
          $('form[action="/localization"]').submit();
        });
      },
    };
  })();

  core.init();
  popupApp.init();

  $(".js-product-buy").on("click", function (e) {
    // TODO BUNDLES
    if (!window.USE_NEW_BUNDLES) {
      addToCart(e?.currentTarget);
    }
  });

  document.querySelectorAll(".js-product-form").forEach(function (form) {
    // TODO BUNDLES
    if (!window.USE_NEW_BUNDLES) return;
    const submitButtons = form.querySelectorAll("[type='submit']");
    submitButtons.forEach(function (b) {
      // Fix the buggy cart app, prevent from ruining listeners
      b.classList.add("button-bundle");
      b.setAttribute("data-bundle-addtocart", "1");
    });
    form.addEventListener("submit", function handleSubmit(e) {
      theme.addToCart(e.currentTarget);
    });
  });

  theme.collectionTemplate = (function () {
    var selectors = {
      sidebar: "#CollectionSidebar",
      activeTagList: ".tag__list--selected",
      tags: ".tag__list a",
      filters: ".collection-filter",
    };

    var settings = {
      combineTags: $(selectors.sidebar).data("combine-tags"),
    };

    var classes = {
      activeTag: "tag__item--active",
      removeTagParent: "tag__item--remove",
    };

    function productVariantsColors() {
      $(".thumbs .thumb__img").on("click", function () {
        let item = $(this).parents(".item");
        let newImg = $(this).data("variant-img");

        let mainImg = item.find(".item__imageSrc");
        let secondImg = item.find(".item__imageSrcSecond");
        mainImg.hide();
        secondImg
          .removeClass("lazyloaded")
          .removeAttr("style")
          .addClass("lazyload")
          .show();
        secondImg.attr("data-bg", newImg);
      });

      $(".thumb__item--more").on("click", function () {
        $(this).parent().addClass("is-open");
      });
    }
    function moreProductsload() {
      $(".js-pagination .btn").on("click", function (e) {
        e.preventDefault();
        getNewCollectionContent($(this).attr("href"), "pagination");
      });
    }

    function init() {
      moreProductsload();
      productVariantsColors();

      initTagClicks();
    }

    function initTagClicks() {
      $(selectors.tags).on("click", function (evt) {
        var $el = $(this);

        if ($el.hasClass("no-ajax")) {
          return;
        }

        evt.preventDefault();
        /*
        if (isAnimating) {
          return;
        }
 
        isAnimating = true;
        */

        var $el = $(evt.currentTarget);
        var $parent = $el.parent();
        var newUrl = $el.attr("href");

        if (settings.combineTags) {
          if ($parent.hasClass(classes.activeTag)) {
            $parent.removeClass(classes.activeTag);
          } else {
            $parent.addClass(classes.activeTag);

            // If adding a tag, show new tag right away.
            // Otherwise, remove it before ajax finishes
            if ($el.parent(".tag__item").hasClass(classes.removeTagParent)) {
              $(this).parent().remove();
            } else {
              $(selectors.activeTagList).append(
                '<div class="tag__item tag__item--remove"><a class="tag__link js-no-transition">' +
                  $el.text() +
                  "</a></div>",
              );
            }
          }
        } else {
          $(selectors.tags).parent().removeClass(classes.activeTag);
          $parent.addClass(classes.activeTag);
        }

        updateScroll(true);

        history.pushState({}, "", newUrl);
        getNewCollectionContent(newUrl, "filter");
      });
    }

    function updateScroll(animate) {
      var scrollTo;
      if (theme.config.bpSmall) {
        // 60 is ~ height of sticky filters
        scrollTo = $("[data-scroll-to]").offset().top - 60;
      } else {
        scrollTo =
          $("#CollectionAjaxResult").offset().top -
          $(".header").outerHeight() -
          20;
      }

      if (theme.config.stickyHeader) {
        var heightOfStickyNav = $(".site-header").outerHeight(true);
        scrollTo = scrollTo - heightOfStickyNav;
      }

      if (animate) {
        $("html, body").animate({ scrollTop: scrollTo }, 300);
      } else {
        $("html, body").scrollTop(scrollTo);
      }
    }

    function getNewCollectionContent(url, type) {
      core.showLoader();

      //   url = url + '?view=ajax';

      $contentCache = $(".js-content-cache");
      loadUrl = url;
      loadContent = loadUrl + " .js-collection-data-content";
      loadData = "";
      loadDataHistory = loadUrl;
      $contentCache = $(".js-content-cache");

      $contentCache.load(loadContent, loadData, function () {
        window.history.replaceState({}, "", loadDataHistory);

        if (type == "pagination") {
          $(".js-collection-data .js-products-row").append(
            $(".js-content-cache .js-products-row").html(),
          );
        } else {
          $(".js-collection-data .js-products-row").html(
            $(".js-content-cache .js-products-row").html(),
          );
        }
        if (type == "filter") {
          $(".js-collection-data .js-filter-content").html(
            $(".js-content-cache .js-filter-content").html(),
          );
        }

        $(".js-collection-data .js-products-counter").html(
          $(".js-content-cache .js-products-counter").html(),
        );
        $(".js-collection-data .js-pagination").html(
          $(".js-content-cache .js-pagination").html(),
        );

        $(".js-content-cache").html("");

        core.hideLoader();
        theme.reinitSection("collection-template");
        theme.collectionTemplate.reinit();
      });
    }

    function reinit() {
      moreProductsload();
      productVariantsColors();
      settings.combineTags = $(selectors.sidebar).data("combine-tags");
      theme.reinitProductGridItem();
      initTagClicks();

      // Custom code: adjust AUS
      try {
        StampedFn.loadBadges();
      } catch (error) {
        console.error(error);
      }
    }

    return {
      init: init,
      reinit: reinit,
      getNewCollectionContent: getNewCollectionContent,
    };
  })();

  theme.predictiveSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;
    var namespace = ".predictive";

    var selectors = {
      form: "#HeaderSearchForm",
      input: 'input[type="search"]',
      wrapper: ".predictive-results",

      searchButton: "[data-predictive-search-button]",

      resultDiv: "#PredictiveResults",
      resultTemplate: "#search-results",
    };

    var classes = {
      isActive: "predicitive-active",
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      // Only some languages support predictive search
      if (document.getElementById("shopify-features")) {
        var supportedShopifyFeatures = JSON.parse(
          document.getElementById("shopify-features").innerHTML,
        );
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      $(selectors.form).attr("autocomplete", "off");

      $(selectors.input, selectors.form).on("keyup" + namespace, handleKeyup);
      $(selectors.searchButton, selectors.wrapper).on(
        "click" + namespace,
        triggerSearch,
      );

      // Prep handlebars template
      var source = $(selectors.resultTemplate).html();

      resultTemplate = Handlebars.compile(source);
    }

    function reset() {
      core.hideLoader();
      $body.removeClass("js-search-show-suggested");

      clearTimeout(searchTimeout);
    }

    function triggerSearch() {
      $(selectors.form).trigger("submit");
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        navigationEvent(evt, "up");
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        navigationEvent(evt, "down");
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
      core.showLoader();
    }

    function search() {
      var keyword = $(selectors.input, selectors.form).val();

      if (keyword === "") {
        reset();

        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500,
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        core.hideLoader();
        return;
      }

      currentString = q;
      isLoading = true;

      jQuery
        .getJSON("/search/suggest.json", {
          q: q,
          resources: {
            type: theme.settings.predictiveSearchType,
            limit: 6,
            options: {
              unavailable_products: "last",
              fields: "title,product_type,variants.title,vendor",
            },
          },
        })
        .done(function (response) {
          core.hideLoader();
          isLoading = false;
          var data = {};
          var resultCount = 0;

          $body.addClass("js-search-show-suggested");
          //$(selectors.wrapper).removeClass('hide');

          var resultTypes = Object.entries(response.resources.results);

          for (var i = resultTypes.length - 1; i >= 0; i--) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              default:
                //data[type] = parseResultImages(results);
                break;
            }
          }

          if (resultCount === 0) {
            reset();
          }

          // Append result markup
          $(selectors.resultDiv).empty().append(resultTemplate(data));
        });
    }

    function buildProducts(results) {
      var products = [];

      for (var i = results.length - 1; i >= 0; i--) {
        var product = results[i];

        var new_product = {
          title: product.title,
          url: product.url,
          //image: theme.Images.lazyloadImagePath(product.image),
          vendor: product.vendor,
          price: theme.Currency.formatMoney(product.price),
          compare_price_max: theme.Currency.formatMoney(
            product.compare_at_price_max,
          ),
          on_sale:
            parseInt(product.compare_at_price_max) > parseInt(product.price),
          custom_label: _checkCustomLabel(product.tags),
        };

        products.push(new_product);
      }

      return products;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function parseResultImages(results) {
      for (var i = results.length - 1; i >= 0; i--) {
        if (!results[i].image) {
          continue;
        }

        var image = theme.Images.lazyloadImagePath(results[i].image);
        results[i].image = image;
      }

      return results;
    }

    function _checkCustomLabel(tags) {
      if (!tags.length) {
        return false;
      }

      for (var i = tags.length - 1; i >= 0; i--) {
        if (tags[i].indexOf("_label_") !== -1) {
          return tags[i].replace("_label_", "");
        }
      }

      return false;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function navigationEvent(evt, direction) {}

    return {
      init: init,
    };
  })();

  function addToCart() {
    // Check if there are unsaved bundles
    const unselectedBundle = document.querySelector(
      ".group--bundle.is-not-selected .group__value:checked",
    );
    if (unselectedBundle) {
      return popupApp.open("bundle--" + unselectedBundle.dataset.popupNum);
    }

    // Check if there are unsaved accessories
    const unselectedAcc = document.querySelector(
      ".group--accessories.is-not-selected .group__value:checked",
    );
    if (unselectedAcc) {
      return popupApp.open("accessories");
    }

    accessoriesApp.addToCart();
  }

  // Add save button event listeners for bundles
  document.querySelectorAll("[data-save-bundle-id]").forEach((btn) => {
    btn.addEventListener("click", () => {
      // Marks current bundle as selected
      const bundleId = btn.dataset.saveBundleId;

      // TODO BUNDLES
      if (window.USE_NEW_BUNDLES) {
        const bundleDiv = document.querySelector(
          `.bundles__bundle-section[data-bundle-id="${bundleId}"] > div`,
        );
        bundleDiv.classList.remove("is-not-selected");
        bundleDiv.classList.add("is-selected");
      } else {
        const bundle = document.querySelector(
          `[data-bundle-id="${bundleId}"] > div`,
        );
        bundle.classList.remove("is-not-selected");
        bundle.classList.add("is-selected");
      }
    });
  });

  // Add save button event listeners for accessories
  document
    .querySelectorAll("[data-save-accessories-prod-id]")
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        // Marks all currently checked accessories as selected
        const currUnselectedAcc = document.querySelectorAll(
          ".group--accessories.is-not-selected .group__value:checked",
        );
        currUnselectedAcc.forEach((el) => {
          el.parentElement.classList.remove("is-not-selected");
          el.parentElement.classList.add("is-selected");
        });
      });
    });

  $(".js-bundle-submit").on("click", function () {
    // TODO BUNDLES
    if (window.USE_NEW_BUNDLES) return;
    let num = $(".product__combo .group--bundle .group__value:checked").data(
      "popup-num",
    );
    if (
      $(
        ".product__combo--accessories .group--accessories.is-not-selected .group__value:checked",
      ).length > 0
    ) {
      popupApp.open("accessories");
    } else {
      popupApp.open("bundle--" + num);
    }
  });

  if (theme.settings.predictiveSearch) {
    theme.predictiveSearch.init();
  }

  theme.collectionTemplate.init();

  function checkBundleSelected() {
    if ($(".js-bundle-check:checked").length > 0) {
      // $(".js-bundle-submit").show();
      // $(".js-product-buy").hide();
      $(".group--orig .group__value").prop("checked", false);
      $(".hs-container-dynamic-stacked.hs-cross-sell").hide();
    } else {
      // $(".js-bundle-submit").hide();
      // $(".js-product-buy").show();
      $(".group--orig .group__value").prop("checked", true);
      $(".hs-container-dynamic-stacked.hs-cross-sell").show();
    }
  }

  checkBundleSelected();
  $(".js-bundle-check, .js-orig-check").on("change", function () {
    $(".js-bundle-check").not($(this)).prop("checked", false);
    checkBundleSelected();
  });

  $(".is-touchdevice .js-main-menu .nav__item.is-dd > .nav__link").on(
    "click",
    function (e) {
      e.preventDefault();
      $(".nav__menu").toggleClass("is-show-lvl-2");
      $(this).parents(".nav__item:first").toggleClass("is-open");
      $body.addClass("js-show-menu");
    },
  );

  $(".is-no-touchdevice .subnav__group .subnav__item").on(
    "mouseenter",
    function () {
      let group = $(this).parents(".nav__dd:first");
      let id = $(this).data("value");
      group.find(".subnav__goods").removeClass("is-open");
      group.find(".subnav__item").removeClass("is-open");
      $(
        '.subnav__goods[data-goods="' +
          id +
          '"], .subnav__item[data-value="' +
          id +
          '"]',
      ).addClass("is-open");
    },
  );

  $(".is-touchdevice .subnav__group .subnav__item").on("click", function (e) {
    e.preventDefault();

    let id = $(this).data("value");
    $(".nav__menu").addClass("is-show-lvl-3");
    $(".subnav__goods, .subnav__item").removeClass("is-open");
    $(
      '.subnav__goods[data-goods="' +
        id +
        '"], .subnav__item[data-value="' +
        id +
        '"]',
    ).addClass("is-open");
  });

  $(".is-touchdevice .nav__menu .js-back").on("click", function (e) {
    $(".nav__menu").removeClass("is-show-lvl-3");
  });

  $(".js-toggle-mobile-nav").on("click", function (e) {
    e.preventDefault();
    $body.toggleClass("js-show-menu");
    $(".nav__menu").removeClass("is-show-lvl-2");
    $(".nav__item.is-dd.is-open").removeClass("is-open");

    document.querySelector(".nav__menu.nav__menu--top").style.display = "block";
  });

  /*
	if(!$.cookie('agree_message')){  
		popupApp.open('cookie-agree');
	}
   */

  $(".js-cookie-submit").on("click", function () {
    $.cookie("agree_message", "hide", { path: "/" });
    popupApp.clear();
  });

  $(".selectBox .selectBox__name").on("click", function (e) {
    e.preventDefault();
    $(this).parents(".selectBox").toggleClass("is-open");
  });

  $(".selectBox .selectBox__option").on("click", function (e) {
    e.preventDefault();
    let $this = $(this).parents(".selectBox");

    $this.find(".selectBox__option").removeClass("is-selected");
    $(this).addClass("is-selected");
    $this.find(".selectBox__value").html($(this).html());
    $this.removeClass("is-open");
    if ($this.hasClass("js-sort-selectbox")) {
      let url = $this.data("url") + "?sort_by=" + $(this).data("value");

      theme.collectionTemplate.getNewCollectionContent(url, "sort");
    }
  });

  $("body").on("click", function (e) {
    if ($(e.target).closest(".selectBox").length == 0) {
      $(".selectBox.is-open").removeClass("is-open");
    }
  });

  const homeSlider = new Swiper(".js-swiper-slider .swiper", {
    speed: 600,
    effect: "fade",
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
      //disableOnInteraction: true
    },
    pagination: {
      el: ".js-swiper-slider .swiper-pagination",
      clickable: "true",
      type: "bullets",
      renderBullet: function (index, className) {
        return (
          '<span class="' +
          className +
          '">' +
          "<em>" +
          "</em>" +
          "<i></i>" +
          "<b></b>" +
          "</span>"
        );
      },
    },
  });

  const galleryPreview = new Swiper(".js-product-gallery-preview", {
    watchSlidesVisibility: true,
    spaceBetween: 0,
    pagination: {
      el: ".gallery__preview .swiper-pagination",
      clickable: "true",
      type: "bullets",
    },
  });

  const relatedArticles = new Swiper(".js-articles--carousel", {
    spaceBetween: 22,
    freeMode: true,
    slidesPerView: "auto",
    pagination: {
      el: ".js-articles--carousel .swiper-pagination",
      clickable: "true",
      type: "bullets",
    },
  });

  const homeAds = new Swiper(".js-header-msg .swiper", {
    loop: true,
    speed: 600,
    watchSlidesVisibility: true,
    effect: "fade",
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".js-header-msg .swiper__arrow--right",
      prevEl: ".js-header-msg .swiper__arrow--left",
    },
    autoplay: { delay: 3000, disableOnInteraction: true },
  });

  const homeSubmenu = new Swiper(".js-submenu-carousel .swiper", {
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    breakpoints: {
      991: { freeMode: false, slidesPerView: 7 },
    },
  });

  const productsCarouselindex = new Swiper(".js-products-carousel .swiper", {
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 16,
    breakpoints: {
      1199: { freeMode: false, slidesPerView: 3, spaceBetween: 22 },
    },
  });

  const homeBannersCarousel = new Swiper(".js-index-banners-carousel .swiper", {
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 22,
    breakpoints: {
      1199: { freeMode: false, slidesPerView: 4, spaceBetween: 22 },
    },
  });

  const tabsCarousel = new Swiper(".js-tabs-links--carousel .swiper", {
    freeMode: true,
    slidesPerView: "auto",
    spaceBetween: 40,
  });

  /*
	if($('*[data-fancybox]').length){
		$.fancybox.defaults.protect = true;
		$.fancybox.defaults.buttons = ['close'];
	}
 */

  Shopify.onCartUpdate = function (cart) {
    console.log(cart.item_count);
  };
  $(".js-search-open").on("click", function () {
    $body.addClass("js-show-search");
    $(".header .search .form__control").focus();
  });

  $(".js-search-close").on("click", function () {
    $body.removeClass("js-show-search");
    $body.removeClass("js-search-show-suggested");
  });

  $(".selectBox .selectBox__title").on("click", function (e) {
    e.preventDefault();
    $(".selectBox--is-open").toggleClass("selectBox--is-open");
    $(this).parents(".selectBox:first").toggleClass("selectBox--is-open");
  });

  $("body").on("click", function (e) {
    if ($(e.target).closest(".selectBox").length == 0) {
      $(".selectBox--is-open").removeClass("selectBox--is-open");
    }
  });

  function declOfNum(n, text_forms) {
    n = Math.abs(n) % 100;
    var n1 = n % 10;
    if (n > 10 && n < 20) {
      return text_forms[2];
    }
    if (n1 > 1 && n1 < 5) {
      return text_forms[1];
    }
    if (n1 == 1) {
      return text_forms[0];
    }
    return text_forms[2];
  }

  $(".js-clear-handlers").on("click", function () {
    $body.removeClass("js-show-search");
    $body.removeClass("js-search-show-suggested");
    $body.removeClass("js-show-filter");
    $body.removeClass("js-h-catalog-over");
    $body.removeClass("js-h-menu-show");
    $body.removeClass("js-show-menu");
    popupApp.clear();
  });

  $(window).on("resize", function () {
    core.initResize();
  });

  if ($(".product-page").length) {
    let reviews_rating = $(".jdgm-rev-widg").data("average-rating");
    let reviews_count = $(".jdgm-rev-widg").data("number-of-reviews");
    $(".jdgm-rev-widg__summary").append(
      '<div class="reviews__header">' +
        reviews_rating +
        "<span>/5</span></div>",
    );
    $(".jdgm-rev-widg__summary-stars").append(
      '<span class="reviews__count"><a href="https://judge.me/reviews/nakedoptics.myshopify.com">' +
        reviews_count +
        " Review</a></span>",
    );
  }

  var arr = [];
  var arr_prev = {};

  $(".js-heroes-grid .js-hero-item").each(function () {
    var cat_handle = $(this).data("sport");
    if (!arr.includes(cat_handle)) {
      arr.push({ title: cat_handle });
    }
  });

  var filteredData = arr.filter(function (item) {
    var key = item["title"];
    if (arr_prev[key]) return false;
    return (arr_prev[key] = true);
  });

  $(".js-heroes-sorter").append(
    '<div class="sort__item is-selected" data-target="all"><span class="sort__link">All</span></div>',
  );

  $.each(filteredData, function (i, item) {
    $(".js-heroes-sorter").append(
      '<div class="sort__item"  data-target="' +
        item["title"] +
        '"><span class="sort__link">' +
        item["title"] +
        "</span></div>",
    );
  });

  $(".js-heroes-sorter .sort__item").on("click", function () {
    var handle = $(this).data("target");
    $(".js-heroes-sorter .sort__item").removeClass("is-selected");

    if (handle == "all") {
      $(".js-heroes-grid .js-hero-item").addClass("is-visible");
    } else {
      $(".js-heroes-grid .js-hero-item").removeClass("is-visible");
      $('.js-heroes-grid .js-hero-item[data-sport="' + handle + '"]').addClass(
        "is-visible",
      );
    }
    $(this).addClass("is-selected");
    heroesPagerCalc();
  });

  function heroesPagerCalc() {
    let setVisible = parseInt($(".js-heroes-grid").data("visible"));
    let progress = 0;
    let allCount = $(".js-heroes-grid .js-hero-item").length;
    let visibleCount = $(".js-heroes-grid .js-hero-item.is-visible").length;
    let pecentage = Math.round(100 / (allCount / visibleCount));

    $(".js-pagination-more").show();

    if (visibleCount <= allCount) {
      $(".js-pagination-family").show();
      $(".js-show-counter").text(visibleCount);
      $(".js-total-counter").text(allCount);
      $(".js-progress-value").css("width", pecentage + "%");
    }
    if (visibleCount >= allCount) {
      $(".js-pagination-more").hide();
    }
  }

  heroesPagerCalc();

  function checkPrices(a, b, c, d) {
    let title = a;
    let price = b;
    let oldPrice = c;
    let type = d;

    if (type == "default") {
      title = $(".js-main-product-selectbox option:selected").text();
    }

    $(".minicart .minicart__variant").html(title);
    $(".minicart .price--default").html(price);
    $(".minicart .price--old").html(oldPrice);
  }
  $(".product__combo--bundle .group__value").on("change", function () {
    let item = $(this).parents(".group:first");
    let price = item.find(".price--default").html();
    let oldPrice = item.find(".price--old").html();
    let title = item.find(".group__title").html();
    let type = "bundle";
    if (item.hasClass("group--orig")) {
      type = "default";
    }
    checkPrices(title, price, oldPrice, type);
  });

  function checkAccessories() {
    let accsTitles = "";
    let accsPrices = 0;
    $(".product__combo--accessories .group__value:checked").each(function () {
      let item = $(this).parents(".group:first");
      let title = item.find(".group__title").html();
      let price = item.data("price");
      accsTitles += " + " + title + " (" + price + ")<br>";
      //accsPrices = accsPrices + price;
    });

    $(".js-product-accessories").html(accsTitles);
  }
  $(".product__combo--accessories .group__value").on("change", function () {
    checkAccessories();
  });

  $(".shopify-policy__body").addClass("editor");
  if ($(".popup--filter .tag__list .tag__item").length > 1) {
    $(".catalog__sort .filter__button").addClass("is-show-filter");
  }

  $(".js-pagination-more").on("click", function () {
    let setVisible = parseInt($(".js-heroes-grid").data("visible"));
    $(
      ".js-heroes-grid .js-hero-item:not(.is-visible):lt(" + setVisible + ")",
    ).addClass("is-visible");
    heroesPagerCalc();
  });
});
